export const isElement = (obj: unknown): obj is Element => {
  return obj instanceof Element;
};

export const isHTMLElement = (obj: unknown): obj is HTMLElement => {
  return obj instanceof HTMLElement;
};

export const isTextNode = (obj: unknown): obj is Text => {
  return obj instanceof Text;
};

export const isNonNullable = <T>(value: T): value is NonNullable<T> => {
  return value !== null && value !== undefined;
};
